/* eslint-disable arrow-body-style */
/* eslint-disable no-underscore-dangle */
import { createSlice } from '@reduxjs/toolkit';
// import { deleteDashboardAsync } from 'redux/dashboard/dashboardActions';
import {
    // deleteFolderAsync,
    getFoldersAsync,
    getFoldersList,
    getRecentDashboards,
    searchDashboard,
} from './folderActions';

const initialState = {
    folders: [],
    files: [],
    foldersList: [],
    recents: [],
    searchList: [],
    noSearchResults: false,
};

export const folderSlice = createSlice({
    name: 'folderSlice',
    initialState,
  
    extraReducers: builder => {
        builder
          
           
    },
});

export const { addFolder, resetSearchList, resetRecentDashboards } =
    folderSlice.actions;

export const getBrowseData = state => state.browse;

export const getFolders = state => state.browse?.folders;

export const getSearchList = state => state.browse.searchList;

export default folderSlice.reducer;
